import React, { useEffect } from "react";
import { useAdminStore } from "@/lib/stores/admin-store";
import { AdminOverviewPage } from "@/components/admin/AdminOverview";

export default function Overview() {
  const { isInitialized, initialize } = useAdminStore();

  useEffect(() => {
    if (!isInitialized) {
      initialize();
    }
  }, [isInitialized, initialize]);

  if (!isInitialized) {
    return (
      <div className="flex items-center justify-center min-h-64">
        <div className="w-8 h-8 border-4 border-sand-400 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return <AdminOverviewPage />;
} 